import { useEffect } from "react";

const getOptionLabel = (option) =>
  typeof option === "object"
    ? option.label
    : option;

const getOptionValue = (option) =>
  typeof option === "object"
    ? option.value
    : option;

const TableRenderer = ({
  question,
  value = {},
  formData = {},
  onChange
}) => {

  const schema =question.ui_schema || {};
  const isStackedLayout = schema.layout === "stacked";
  const rows = schema.fixed_rows
  ? (schema.rows || [])
  .filter(
    (schemaRow) =>
      !schemaRow.field_key
  )
  .map(

      (schemaRow, index) => {

        if (schemaRow.type === "section" || schemaRow.field_key) 
        {
            return schemaRow;
          }

        let savedRow = {};

        if (schemaRow.category) {

          savedRow =
            value?.rows?.find(
              (r) =>
                r.category ===
                schemaRow.category
            ) || {};

        } else {

          savedRow =
            value?.rows?.[index] || {};

        }

        return {
          ...schemaRow,
          ...savedRow
        };
      }
    )
  : (
      value?.rows?.length > 0
        ? value.rows
        : [{}]
    );
     

      const stakeholderSourceColumn =
  schema.columns?.find(
    (c) => c.source_question_code
  );

let availableDynamicOptions = [];

if (stakeholderSourceColumn) {

  const sourceQuestion =
    formData[
      stakeholderSourceColumn
        .source_question_code
    ];

  const sourceRows =
    sourceQuestion?.rows || [];

  availableDynamicOptions =
    sourceRows
      .map(
        (r) => r.stakeholder_group
      )
      .filter(Boolean);
}
  // ====================================
  // UPDATE CELL
  // ====================================

  const updateCell = (
    rowIndex,
    key,
    cellValue
  ) => {
    const updated =[...rows];
    // ====================================
    // GENERIC MAX_FROM VALIDATION
    // ====================================

          const currentColumn =
            schema.columns?.find(
              (c) => c.key === key
            );

          if (
            currentColumn?.max_from
          ) {

            const maxValue =
              Number(
                updated[rowIndex]?.[
                  currentColumn.max_from
                ] || 0
              );

            if (
              maxValue > 0 &&
              Number(cellValue) > maxValue
            ) {

              return;

            }

}


    updated[rowIndex] = {
      ...updated[rowIndex],
      [key]: cellValue
    };

// ====================================
// AUTO TOTAL ROWS
// ====================================

if (schema.auto_totals) {

  schema.auto_totals.forEach(
    (rule) => {

      const sourceRows =
        updated.filter(
          (r) =>
            rule.sources.includes(
              r.category
            )
        );

      const targetRow =
        updated.find(
          (r) =>
            r.category ===
            rule.target
        );

      if (!targetRow) {
        return;
      }

      rule.fields.forEach(
        (field) => {

          targetRow[field] =
            sourceRows.reduce(
              (sum, row) =>
                sum +
                Number(
                  row[field] || 0
                ),
              0
            );

        }
      );

    }
  );

}

    onChange(
      question.question_code,
      {
        ...value,
        rows: updated
      }
    );
  };

  // ====================================
  // ADD ROW
  // ====================================

  const addRow = () => {

    onChange(
      question.question_code,
      {
        ...value,
        rows: [
          ...rows,
          {}
        ]
      }
    );
  };

  // ====================================
  // REMOVE ROW
  // ====================================

  const removeRow = (
    rowIndex
  ) => {

    const updated =
      rows.filter(
        (_, i) => i !== rowIndex
      );

    onChange(
      question.question_code,
      {
        ...value,
        rows: updated
      }
    );
  };

  // ====================================
  // FILE CHANGE
  // ====================================

  const handleFileChange = (
    e
  ) => {

    const files =
      Array.from(
        e.target.files || []
      );

    onChange(
      question.question_code,
      {
        ...value,
        rows,
        evidence_files: files
      }
    );
  };
// ====================================
// FIELD RENDERER
// ====================================

const renderField = (
  column,
  row,
  rowIndex
) => {

  let options =
    column.options || [];

return column.readonly ? (

  <div className="ecf-readonly-cell ecf-title">
    {row[column.key]}
  </div>

) : column.type === "derived" ? (() => {

  let derivedValue = 0;

  try {

    let formula =
      column.formula;

    Object.keys(row).forEach(
      (key) => {

        formula =
          formula.replaceAll(
            key,
            Number(
              row[key] || 0
            )
          );

      }
    );

    derivedValue =
      eval(formula);

    if (
      isNaN(
        derivedValue
      ) ||
      !isFinite(
        derivedValue
      )
    ) {

      derivedValue = 0;
    }

    derivedValue =
      Number(
        derivedValue
      ).toFixed(2);

  } catch {

    derivedValue = 0;
  }

  return (

    <input
      type="text"
      className="org-field-input"
      value={`${derivedValue}%`}
      disabled
      readOnly
    />

  );

})()

: column.type === "textarea" ? (

    <textarea
      className="org-field-input"
      disabled={row.readonly_row}
      rows={column.rows || 4}
      placeholder={column.placeholder}
      value={row[column.key] || ""}
      onChange={(e) =>
        updateCell(
          rowIndex,
          column.key,
          e.target.value
        )
      }
    />

  ) : column.type === "select" ? (

    <select
      className="org-field-input"
      disabled={row.readonly_row}
      value={
        row[column.key] || ""
      }
      onChange={(e) =>
        updateCell(
          rowIndex,
          column.key,
          e.target.value
        )
      }
    >

      <option value="">
        Select
      </option>

     {options.map((option) => (

  <option
    key={getOptionValue(option)}
    value={getOptionValue(option)}
  >
    {getOptionLabel(option)}
  </option>

))}

    </select>

  ) : (

    <input
      type={
        column.type || "text"
      }
      className="org-field-input"
      placeholder={
        column.placeholder
      }
      value={
        row[column.key] || ""
      }
      onChange={(e) =>
        updateCell(
          rowIndex,
          column.key,
          e.target.value
        )
      }
    />

  );

};

// ====================================
// STACKED LAYOUT
// ====================================

if (isStackedLayout) {

  return (

    <div className="ecf-stacked-table">

      {rows.map(
        (row, rowIndex) => (

        <div
            key={rowIndex}
            className="ecf-stacked-card"
          >
                {!schema.fixed_rows && (

                  <div className="ecf-card-actions">

                    <button
                      type="button"
                      className="ecf-remove-btn"
                      onClick={() =>
                        removeRow(rowIndex)
                      }
                    >
                      ✕
                    </button>

                  </div>

                )}
            {schema.columns.map(
  (column) => (

    <div
            key={column.key}
            className={`
              ecf-stacked-field
              ${schema.grid_columns
                ? `ecf-stacked-field-${schema.grid_columns}`
                : ""
              }
              ${column.full_width
                ? "ecf-stacked-field-full"
                : ""
              }
            `}
            >

     <label
        className={column.key === "category" ? "ecf-cat-title" : ""}
      >
      {column.label}
      </label>

      {renderField(
        column,
        row,
        rowIndex
      )}



    </div>

  )
)}

          </div>

        )
      )}

      {!schema.fixed_rows && (

        <button
          type="button"
          className="org-btn-save"
          onClick={addRow}
        >
          + Add Row
        </button>

      )}

    </div>

  );

}
const beforeTableFields =
  (schema.rows || []).filter(
    row =>
      row.field_key &&
      row.position === "before_table"
  );

const afterTableFields =
  (schema.rows || []).filter(
    row =>
      row.field_key &&
      row.position === "after_table"
  );

  return (

  <>
  {beforeTableFields.map((field) => (

  <div
    key={field.field_key}
    className="ecf-sub-question"
  >

    <label>
      {field.label}
    </label>

    {field.type === "textarea" ? (

      <textarea
        className="org-field-input"
        rows={field.rows || 4}
        value={
          value?.[field.field_key] || ""
        }
        onChange={(e) =>
          onChange(
            question.question_code,
            {
              ...value,
              [field.field_key]:
                e.target.value
            }
          )
        }
      />

    ) : (

      <input
        type={field.type || "text"}
        className="org-field-input"
        value={
          value?.[field.field_key] || ""
        }
        onChange={(e) =>
          onChange(
            question.question_code,
            {
              ...value,
              [field.field_key]:
                e.target.value
            }
          )
        }
      />

    )}

  </div>

))}
  <div className="ecf-table-wrapper">


      <table className="ecf-table">

        <thead>

          <tr>

            {schema.columns.map(
              (column) => (

                <th key={column.key}>
                  {column.label}
                </th>

              )
            )}

            <th></th>

          </tr>

        </thead>


          <tbody>

            {rows.map((row, rowIndex) => {

              // ====================================
              // SECTION ROW
              // ====================================

              if (row.type === "section") {

                return (
                  <tr
                    key={`section-${rowIndex}`}
                    className="ecf-section-row"
                  >
                    <td
                      colSpan={
                        schema.columns.length + 1
                      }
                    >
                      <strong>{row.label}</strong>
                    </td>
                  </tr>
                );

              }

    return (
              <tr key={rowIndex}>

                {schema.columns.map(
                  (column) => {

                    // ====================================
                    // DYNAMIC OPTIONS
                    // ====================================

                    let options =
                      column.options || [];

                  // ====================================
                  // DYNAMIC SOURCE OPTIONS
                  // ====================================

                  if (
                    column.source_question_code ||
                    column.unique_options
                  ) {

                    const selectedValues =
                      rows
                        .map((r, i) =>
                          i !== rowIndex
                            ? r[column.key]
                            : null
                        )
                        .filter(Boolean);

                    options =
                    options.filter(
                      (option) =>
                        !selectedValues.includes(
                          getOptionValue(option)
                        )
                    );

                  }

                    return (

                  <td key={column.key}>

                    {/* DERIVED */}

                    {column.type ===
                    "derived" ? (() => {

                      let derivedValue = 0;

                      try {

                        let formula =
                          column.formula;

                        Object.keys(row).forEach(
                          (key) => {

                            formula =
                              formula.replaceAll(
                                key,
                                Number(
                                  row[key] || 0
                                )
                              );

                          }
                        );

                    derivedValue =
                      eval(formula);

                    if (
                      isNaN(
                        derivedValue
                      ) ||
                      !isFinite(
                        derivedValue
                      )
                    ) {

                      derivedValue = 0;
                    }

                derivedValue =
                  Number(
                    derivedValue
                  ).toFixed(2);

              } catch {

                derivedValue = 0;
              }

                  return (

                    <input
                      type="text"
                      className="org-field-input"
                      value={`${derivedValue}%`}
                      disabled
                      readOnly
                    />

                  );

                })()

    /* SELECT */

    : column.type ===
      "select" ? (

      <select
        className="org-field-input"
        value={
          row[column.key] || ""
        }
        onChange={(e) =>
          updateCell(
            rowIndex,
            column.key,
            e.target.value
          )
        }
      >

        <option value="">
          Select
        </option>

        {options.map((option) => (

              <option
                key={getOptionValue(option)}
                value={getOptionValue(option)}
              >
                {getOptionLabel(option)}
              </option>

            ))}

                  </select>

    ) : (

      column.readonly ? (

  <div
  className={
    row.readonly_row
      ? "ecf-readonly-cell ecf-title"
      : "ecf-readonly-cell"
  }
>
    {row[column.key]}
  </div>

) : column.type === "textarea" ? (

  <textarea
    className="org-field-input"
    rows={column.rows || 4}
    placeholder={column.placeholder}
    value={row[column.key] || ""}
    onChange={(e) =>
      updateCell(
        rowIndex,
        column.key,
        e.target.value
      )
    }
  />

) : (

  <input
    type={column.type || "text"}
    disabled={row.readonly_row}
    className="org-field-input"
    placeholder={column.placeholder}
    value={row[column.key] || ""}
    onChange={(e) =>
      updateCell(
        rowIndex,
        column.key,
        e.target.value
      )
    }
  />

)

    )}

  </td>

);

                  }
                )}

                <td>

  {!schema.fixed_rows && (

    <button className="ecf-remove-btn"
      type="button"
      onClick={() =>
        removeRow(
          rowIndex
        )
      }
    >
      ✕
    </button>

  )}

</td>

              </tr>

            );

          })}

        </tbody>

      </table>
      {afterTableFields.map((field) => (

  <div
    key={field.field_key}
    className="ecf-sub-question"
  >

    <label>
      {field.label}
    </label>

    <input
      type={field.type || "text"}
      className="org-field-input"
      value={
        value?.[field.field_key] || ""
      }
      onChange={(e) =>
        onChange(
          question.question_code,
          {
            ...value,
            [field.field_key]:
              e.target.value
          }
        )
      }
    />

  </div>

))}
{schema.note_field && (

  <div className="ecf-table-note">

    <label>
      {schema.note_field.label}
    </label>

    <textarea
      className="org-field-input"
      rows={4}
      value={
        value?.[
          schema.note_field.field_key
        ] || ""
      }
      onChange={(e) =>
        onChange(
          question.question_code,
          {
            ...value,
            [schema.note_field.field_key]:
              e.target.value
          }
        )
      }
    />

  </div>

)}
      {/* EVIDENCE */}

      {schema.file_upload?.enabled && (

        <div className="brsr-upload-wrapper">

          <input
            type="file"
            multiple
            accept={
              schema.file_upload
                ?.accepted_types
                ?.map(
                  (t) => `.${t}`
                )
                .join(",")
            }
            onChange={
              handleFileChange
            }
          />

        </div>

      )}

      {!schema.fixed_rows &&
 (
   !schema.max_rows ||
   rows.length < schema.max_rows
 ) &&
 (
   !stakeholderSourceColumn ||
   rows.length <
   availableDynamicOptions.length
 ) && (

  <button
    type="button"
    className="org-btn-save"
    onClick={addRow}
  >
    + Add Row
  </button>

)}

    </div>
</>
  );
};

export default TableRenderer;